module.exports = __webpack_public_path__ + "img/header.73c7cfe.webp";